function avvioSplideSliderInit() {
  const avvioSplideSlider = ".splide";
  let avvioSplideSliderBlock = document.querySelectorAll(avvioSplideSlider);

  const updateHeroFirstVideoSlide = () => {
    const splideSlider = document.querySelectorAll(".avvio-hero .splide");

    splideSlider.forEach((slider) => {
      const isInitialized = slider.classList.contains("is-initialized");
      if (isInitialized) return false;

      // Reset first slide class
      const firstSlide = slider.querySelector(".splide__slide");
      const heroFirstSlideVideo = firstSlide?.querySelector("video");

      if (heroFirstSlideVideo) {
        heroFirstSlideVideo.classList.remove("js-avvio-hls-video");
        heroFirstSlideVideo.classList.add("js-avvio-first-slide-hls-video");
      }
    });
  };

  const addAutoplayToggleButton = (splide) => {
    if (!splide || Object.keys(splide).length === 0 || !splide.root) return false;

    // Create a new button
    const autoplayToggleButton = document.createElement("button");
    autoplayToggleButton.setAttribute("type", "button");
    autoplayToggleButton.classList.add("splide__autoplay-toggle-button");
    const autoplayToggleButtonText = document.createTextNode("Autoplay toggle");
    autoplayToggleButton.appendChild(autoplayToggleButtonText);
    autoplayToggleButton.style.visibility = "hidden";
    autoplayToggleButton.style.position = "absolute";
    autoplayToggleButton.setAttribute("tabindex", "-1");
    splide.root.appendChild(autoplayToggleButton);

    splide.on("autoplay:play", function () {
      autoplayToggleButton.setAttribute("aria-label", "Pause autoplay");
      autoplayToggleButton.textContent = "Pause";
    });

    splide.on("autoplay:pause", function () {
      autoplayToggleButton.setAttribute("aria-label", "Start autoplay");
      autoplayToggleButton.textContent = "Play";
    });

    autoplayToggleButton.addEventListener("click", function () {
      const Autoplay = splide.Components.Autoplay;

      if (Autoplay.isPaused()) {
        Autoplay.play();
      } else {
        Autoplay.pause();
      }
    });
  };

  if (typeof avvioSplideSliderBlock != "undefined" && avvioSplideSliderBlock != null) {
    // Update the Hero Slider First slide Video Class to initialize video with the Splide slider
    updateHeroFirstVideoSlide();

    for (var i = 0; i < avvioSplideSliderBlock.length; i++) {
      const splideElement = avvioSplideSliderBlock[i];
      const firstSlide = splideElement.querySelector(".splide__slide");
      const heroFirstSlideVideo = firstSlide?.closest(".avvio-hero")?.querySelector("video");

      // State
      let hasAutoplay = false;
      let splide = {};
      let autoplay = {};
      let isAutoplayResumed = false;

      function initSlider(hasFirstVideoSlide) {
        let pagination = splideElement.querySelector(".splide__pagination");
        if (typeof pagination != "undefined" && pagination != null) {
          pagination.remove();
        }

        // SET DEFAULT OPTIONS
        var splideDefaultOptions = {
          type: "loop",
          autoplay: false,
          interval: 6000,
          lazyLoad: "nearby",
          pauseOnHover: false,
          resetProgress: false,
          arrows: false,
          pagination: false,
          gap: 0,
          grid: false,
        };

        splide = new Splide(splideElement, splideDefaultOptions);

        // Add slider Autoplay toggle button
        addAutoplayToggleButton(splide);

        splide.on("autoplay:play", function () {
          hasAutoplay = true;
        });

        let bar = splide.root.querySelector(".avvio-control-bar__progress-bar");
        // Update the bar width:
        if (bar) {
          splide.on("ready move", () => {
            var end = splide.Components.Controller.getEnd() + 1;
            let visible = splide.root.getElementsByClassName("is-visible").length;
            var rate = Math.min((splide.index + visible) / end, 1);

            bar.style.width = String(100 * rate) + "%";
          });
        }

        // Create functionality for the custom pagination
        let customPagination = splideElement.querySelectorAll(".avvio-custom-pagination");
        if (customPagination) {
          // Update the active classes
          // Update the aria-expanded tag
          splide.on("mounted move", () => {
            const avvioSlideButton = document.querySelectorAll(".splide__pagination-button");
            for (const avvioSlideButtons of avvioSlideButton) {
              avvioSlideButtons.setAttribute("aria-expanded", "false");
              avvioSlideButtons.classList.remove("is-active-button");
              if (parseInt(avvioSlideButtons.dataset.page) === splide.index) {
                avvioSlideButtons.classList.add("is-active-button");
                avvioSlideButtons.setAttribute("aria-expanded", "true");
              }
            }
          });

          for (var list = 0; list < customPagination.length; list++) {
            let pageWrapper = customPagination[list];
            let customPaginationButtons = pageWrapper.querySelectorAll(
              ".splide__pagination-button"
            );

            for (var button = 0; button < customPaginationButtons.length; button++) {
              customPaginationButtons[button].addEventListener("click", (e) => {
                let pageNumber = parseInt(e.target.dataset.page);
                splide.go(pageNumber);
              });
            }
          }
        }

        // Remove all of the clones when we update the blocks using Gutenberg, prevents issues in the admin!
        if (
          splideElement.classList.contains("is-initialized") &&
          document.body.classList.contains("wp-admin")
        ) {
          // As splide-grid contains only clones due to the new structure it creates, exit out of this.
          if (splideElement.classList.contains("splide--grid")) return;
          let clones = splideElement.querySelectorAll(".splide__slide--clone");

          clones.forEach((box) => {
            box.remove();
          });
        }

        const setCarouselArrowMaxWidth = (splide, arrowWrapperSelector) => {
          if (!arrowWrapperSelector) return false;

          const arrowWrapper = splide.root.querySelector(arrowWrapperSelector);
          if (!arrowWrapper) return false;

          const slideWidth =
            splide.Components.Slides.getAt(0).slide.offsetWidth;

          arrowWrapper.style.maxWidth = slideWidth + "px";

          return true;
        };

        splide.on("mounted", function () {          
          const carouselSlider = splide.root.closest(".avvio-carousel");
          carouselSlider && setCarouselArrowMaxWidth(splide, ".avvio-carousel__arrows-wrapper");
          
          autoplay = splide.Components.Autoplay;

          // Pause the autoplay if the first slide has video
          if (hasFirstVideoSlide && hasAutoplay) {
            autoplay.pause();
            isAutoplayResumed = false;
          }
        });

        splide.on("moved", function (newIndex, prevIndex, destIndex) {
          // Set the previous slide video from the beginning
          const prevSlide = splide.Components.Slides.getAt(prevIndex).slide;
          const video = prevSlide.querySelector("video");
          video && (video.currentTime = 0);

          // Resume slider autoplay on slide change
          if (hasAutoplay && autoplay.isPaused()) {
            autoplay.play();
            isAutoplayResumed = true;
          }
        });

        // Start the carousels
        splide.mount(window.splide.Extensions);

        // Check if carousel has filters, then handle the filtering if exists
        if (typeof (avvioSplideSliderBlock[i].querySelector('.js-avvio-carousel__filter')) != 'undefined' && avvioSplideSliderBlock[i].querySelector('.js-avvio-carousel__filter') != null) {
          const splideFilter = avvioSplideSliderBlock[i].querySelector('.js-avvio-carousel__filter');
          const splideSlides = splide.Components.Slides.filter(`.splide__slide`);
          let splideList = avvioSplideSliderBlock[i].querySelector('.splide__list');

          // deligate click event
          splideFilter.addEventListener('click', function (e) {

            let filterItem = e.target;

            // if not a filter item stop further execution
            if (!filterItem.classList.contains('avvio-carousel__filter-item')) {
              return;
            }

            // change active class on filter items
            splideFilter.querySelectorAll('.avvio-carousel__filter-item').forEach(function (item) {
              if (item == filterItem) {
                item.classList.add('is-active');
              }
              else {
                item.classList.remove('is-active');
              }
            });

            // empty splide list container
            splideList.innerHTML = '';

            // loop through all pre initialized slides
            splideSlides.forEach(function (item) {
              let filters = item.slide.dataset.filter.split(',');
              if (filters.includes(filterItem.dataset.filter)) {
                splideList.append(item.slide);
              }
            });

            // destroy current splide instance, then remount
            splide.destroy();
            splide.mount();

          });

        }

        return autoplay;
      }

      if (heroFirstSlideVideo) {
        // Initialize the slider
        initSlider(true);

        // Initialize the video JS
        const videoJs = new VideoJs({ selector: ".js-avvio-first-slide-hls-video" });
        // Start the slider autoplay on video load
        videoJs.init([
          {
            eventType: "onended",
            cb() {
              if (hasAutoplay && !isAutoplayResumed) {
                splide.go("+1");
                autoplay.play();
                isAutoplayResumed = true;
              }
            },
          },
        ]);
      } else {
        initSlider();
      }
    }
  }
} // is-initialized

/**
 * Initialize the script when the block is previewed within the editor
 * https://www.advancedcustomfields.com/resources/javascript-api/
 */
if (window.acf) {
  window.acf.addAction("render_block_preview/type=avvio-carousel", avvioSplideSliderInit);
  window.acf.addAction("render_block_preview/type=avvio-logos", avvioSplideSliderInit);
  window.acf.addAction("render_block_preview/type=avvio-testimonials", avvioSplideSliderInit);
  window.acf.addAction("render_block_preview/type=avvio-feature-panel", avvioSplideSliderInit);
  window.acf.addAction("render_block_preview/type=avvio-hero", avvioSplideSliderInit);
  window.acf.addAction("render_block_preview/type=avvio-instagram-feed", avvioSplideSliderInit);
} else {
  document.addEventListener("DOMContentLoaded", avvioSplideSliderInit);
}
